var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak2Lengeh2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.2,15.2h-9.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.9c0.3,0,0.5,0.2,0.5,0.5S52.5,15.2,52.2,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43,19.6 43,9.8 38,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,20.2c-0.3,0-0.5-0.2-0.5-0.5V9.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v9.9C16.1,20,15.9,20.2,15.7,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,15.2H10.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h10.1c0.3,0,0.5,0.2,0.5,0.5C21.2,15,21,15.2,20.7,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,25.9H33.9V3.7H56V25.9z M34.8,24.9H55V4.7H34.8V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,30H0.2V0h30.6V30z M1.1,29h28.6V1H1.1V29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak2Lengeh2);
export default __webpack_public_path__ + "static/media/tak_2_lengeh_2.8fba14f2723e4333d3842c14b1e45a9c.svg";
export { ForwardRef as ReactComponent };